/**
 * A connector's mark on a row: the queue's `.cmark` tile in the connector's
 * colour, holding its monochrome glyph where one is drawn, else its letter.
 */
import type { CSSProperties } from "react";
import { ConnectorGlyph } from "../desks/ConnectorGlyph.js";
import { markColor, type ConnectorRecord } from "./connectorsModel.js";

const DRAWN = new Set([
  "linear",
  "jira",
  "github",
  "sentry",
  "slack",
  "hubspot",
  "notion",
  "stripe",
  "intercom",
  "calendly",
  "figma",
]);

export function ConnectorMark({ record }: { record: ConnectorRecord }) {
  const source =
    record.kind === "request" ? record.item.id : record.kind === "draft" ? "" : record.serviceType;
  return (
    <span className="cmark" style={{ "--c": markColor(record) } as CSSProperties} aria-hidden>
      {DRAWN.has(source) ? (
        <ConnectorGlyph source={source} size={14} title="" />
      ) : (
        record.name.trim().charAt(0).toUpperCase()
      )}
    </span>
  );
}
